<template>
    <div>
    <textarea class="form-control" v-model="handler" @input="change" rows="6"></textarea>
    <div class="helper-text d-flex">
        <strong class="mr-1">*{{_lang('bold')}}*</strong>
        <em class="mr-1">_{{_lang('italic')}}_</em>
        <ins>__{{_lang('underline')}}__</ins>

    </div>
    </div>


</template>
<style scoped>
.helper-text { font-size:.9em}

</style>
<script>



export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      var text = this.value;
      if(!text) return;
        text = text.replace(/<strong>(.+?)<\/strong>/g,'*$1*');
        text = text.replace(/<ins>(.+?)<\/ins>/g,'__$1__');
        text = text.replace(/<em>(.+?)<\/em>/g,'_$1_');
        text = text.replace(/<br.*?>(\n)?/g,"\n");
        this.handler = text;
  },
  methods:{
    change(){
        var text = this.handler;
        text = text.replace(/\*(.+?)\*/g,'<strong>$1</strong>');
        text = text.replace(/__(.+?)__/g,'<ins>$1</ins>');
        text = text.replace(/_(.+?)_/g,'<em>$1</em>');
        text = text.replace(/\n/g,"<br>\n");
        this.$emit('change',text);
    },
  }

}
</script>
